import {Body, Close, Header, Modal} from "@zendeskgarden/react-modals";
import {ReactElement} from "react";
import {TData, TDriverInfo} from "../logic";
import * as css from "./diffmodalsingle.module.scss";
import {ReactComponent as AlertIcon} from '@zendeskgarden/svg-icons/src/16/alert-warning-stroke.svg';
import cn from "classnames";

export interface IDiffModalSingle {
    label: string;
    labelConfigurationColumn: string;
    first: Pick<TData, "property"> & {driverData: TDriverInfo | null};
    second: Pick<TData, "property"> & {driverData: TDriverInfo | null};
    onClose: () => void;
}

export function DiffModalSingle(props: IDiffModalSingle): ReactElement {
    return (
        <Modal onClose={props.onClose} isLarge className={css.modal}>
            <Header>
                {props.label}
            </Header>
            <Body>
                <div className={css.bodyContent}>
                    <div className={css.driverLines}>
                        <div className={css.driverLine}>
                            <span>Property</span><span>{props.labelConfigurationColumn}</span>
                        </div>
                        <div className={css.driverLine}>
                            <span>{props.first.property.name}</span><span>{props.first.driverData?.content ?? "-"}</span>
                        </div>
                        <div className={cn(css.driverLine, css.diffCell)}>
                            <span>{props.second.property.name}</span><span><AlertIcon style={{minHeight: "18px", minWidth: "18px"}} />&nbsp;{props.second.driverData?.content ?? "-"}</span>
                        </div>
                    </div>
                </div>
            </Body>
            <Close aria-label="Close modal" />
        </Modal>
    )
}